export { default } from './StatusIndicator.js';
